// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"22aa32a9","585":"0f7bffbf"}[chunkId] + ".chunk.js";
};